import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircleIcon from "@mui/icons-material/Circle";

const Banner = () => {
  const ColorButton = styled(Button)(() => ({
    color: "#000",
    width: 225,
    height: 65,
    fontWeight: 700,
    fontSize: "16px",
    textTransform: "capitalize",
    backgroundColor: "#fff",
    borderColor: "#fff",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#4f4f4f",
      borderColor: "#4f4f4f",
    },
  }));

  return (
    <Box
      width={{ xs: "100%", sm: "70%" }}
      margin={{ xs: "27% 0%", sm: "10% 0%" }}
      marginLeft={{ xs: "0%", sm: "0%" }}
    >
      <Typography
        variant={"h2"}
        fontWeight={700}
        textAlign={"left"}
        color={"#fff"}
      >
        We work on delivering unique design solutions. Realize your new projects
        with{" "}
        <Typography
          component={"span"}
          variant={"h2"}
          color="#33E68C"
          fontWeight={700}
        >
          ONDESIGN
        </Typography>
      </Typography>
      <Typography
        variant={"body1"}
        fontWeight={400}
        textAlign={"left"}
        paddingTop={{ xs: "5%", sm: "2%" }}
        color={"#fff"}
      >
        Our focus is to create products that deliver best user experience for
        our clients at the optimal level of our unique and creative expertise.
      </Typography>
      <Box padding={{ xs: "7% 2% 0% 0%", sm: "3% 2% 1% 0%" }}>
        <ColorButton
          component={"a"}
          variant="outlined"
          size="medium"
          href={"/contact-us"}
          endIcon={
            <CircleIcon
              sx={{
                color: "#33E68C",
                "&:hover": {
                  color: "#fff",
                },
              }}
            />
          }
        >
          Let's Talk
        </ColorButton>
      </Box>
    </Box>
  );
};

export default Banner;
